var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7999C14.8601 18.7999 18.7999 14.8601 18.7999 10C18.7999 5.13994 14.8601 1.20009 10 1.20009C5.13994 1.20009 1.20009 5.13994 1.20009 10C1.20009 14.8601 5.13994 18.7999 10 18.7999ZM10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99981 13.9808C12.1983 13.9808 13.9806 12.1986 13.9806 10.0001C13.9806 7.80154 12.1983 6.01929 9.99981 6.01929C7.8013 6.01929 6.01905 7.80154 6.01905 10.0001C6.01905 12.1986 7.8013 13.9808 9.99981 13.9808ZM9.99981 15.2382C7.10689 15.2382 4.76172 12.893 4.76172 10.0001C4.76172 7.10714 7.10689 4.76196 9.99981 4.76196C12.8927 4.76196 15.2379 7.10714 15.2379 10.0001C15.2379 12.893 12.8927 15.2382 9.99981 15.2382Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5901 13.423C13.8796 13.1914 14.1428 12.9282 14.3744 12.6387L17.1419 15.4062L16.3576 16.1905L13.5901 13.423ZM6.57612 6.40902L3.80859 3.64149L4.59291 2.85718L7.36043 5.6247C7.07089 5.8563 6.80772 6.11948 6.57612 6.40902Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01906 13.1972C6.25156 13.4859 6.51487 13.7488 6.80401 13.9808L3.72001 17.0648L2.96484 16.2514L6.01906 13.1972ZM13.1901 6.02617L13.5083 5.70791L16.359 2.85718L17.1434 3.64149L13.9737 6.81112C13.7417 6.52198 13.4788 6.25866 13.1901 6.02617Z",
    fill: "#070707"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.cb50724c183f9084f96b9e2b12a261eb.svg";
export { ForwardRef as ReactComponent };